import { lazy } from 'react'

const Login = lazy(() => import('../../pages/authentication/authentication'))
const PasswordForgotten = lazy(() => import('../../pages/authentication/passwordForgotten/passwordForgotten'))
const SignUpPage = lazy(() => import('../../pages/authentication/signUpPage/signUpPage'))
const PasswordReset = lazy(() => import('../../pages/authentication/chooseNewPassword/ChooseNewPassword'))

export const AuthRoutes = [
    {
        element: <Login />,
        path: '/login',
    },
    {
        element: <Login />,
        path: '/padel/login',
    },
    {
        element: <PasswordForgotten />,
        path: '/forgotPassword',
    },
    {
        element: <PasswordForgotten />,
        path: '/padel/forgotPassword',
    },
    {
        element: <SignUpPage />,
        path: '/signup',
    },
    {
        element: <SignUpPage />,
        path: '/padel/signup',
    },
    {
        element: <PasswordReset />,
        path: '/reload/passwordReset',
    },
    {
        element: <PasswordReset />,
        path: '/padel/reload/passwordReset',
    },
]
